import { DuttiDatePrimitive } from '../../../domain/models/dates.models';

/**
 * Replaces all the '-' characters in a date string by '/'
 *
 * @param date Date to fix
 *
 * @returns Fixed date
 */
export function fixDateString(date: DuttiDatePrimitive): DuttiDatePrimitive {
    return typeof date === 'string'
        ? date.replace(/-/g, '/')
        : date;
}
